import { render, staticRenderFns } from "./VideoUrl.vue?vue&type=template&id=4fb500dc&scoped=true&"
import script from "./VideoUrl.vue?vue&type=script&lang=js&"
export * from "./VideoUrl.vue?vue&type=script&lang=js&"
import style0 from "./VideoUrl.vue?vue&type=style&index=0&id=4fb500dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb500dc",
  null
  
)

export default component.exports